import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-95182d8a")

_pushScopeId("data-v-95182d8a")
const _hoisted_1 = { viewBox: "0 0 100 100" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _createVNode("use", { href: _ctx._source }, null, 8, ["href"])
  ]))
})